<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 14:27:03
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-03-07 15:57:42
-->
<template>
  <div>
    <header :class="['head-page', scroll_type == 'down' ? 'navbar-down' : '']">
      <HeadMenu ref="headMenu" :defaultActive="activeMenuIndex" :class="[]"/>
    </header>
    <div class="about">
      <div class="swiper about-swiper" id="aboutSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide about-bj container flex flex_wrap">
            <div class="flex_1 flex flex_col ui-hearder-bj about-bj-box">
              <div class="posrel">
                <div class="about-bj-txt">
                  <div class="hearder-bj-title about-bj-title">{{$t('about.about.title')}}</div>
                  <div class="hearder-bj-des about-bj-des">{{$t('about.about.des')}}</div>
                </div>
              </div>
              <div class="about-bj-list textj">
                <template v-if="language == 'en'">
                  <p class="about-bj-item p-b-30" :class="aboutStatus ? 'show' : ''" v-for="(item, index) in about" :key="index" v-html="item"></p>
                </template>
                <template v-else>
                  <p class="p-b-30" v-for="(item, index) in about" :key="index">
                    <span v-for="($item, $index) in item" :key="index + '_' +$index" :class="aboutActive >= $index + getNum('about', index) ? 'on' : ''" v-html="$item"></span>
                  </p>
                </template>
              </div>
            </div>
            <div class="flex_1 posrel">
              <img class="about-bj-img wid100 center_up_down" :src="require('@/assets/images/about/1.png')" alt="" srcset="">
            </div>
          </div>
          <div class="swiper-slide about-bj about-culture container posrel">
            <div class="posrel hei100">
              <div class="about-culture-box center_up_down">
                <div class="about-about-culture-title">{{$t('about.culture.title')}}</div>
                <div :class="['about-culture-list', cultureStatus ? 'show' : '']" v-for="(item, index) in $t('about.culture.list')" :key="index">
                  <div class="about-culture-list-title flex align_items_center">
                    <div class="about-culture-list-img flex align_items_center"><img :src="require(`@/assets/images/about/2-${index + 1}.png`)" alt="" srcset=""></div>
                    <span>{{item.title}}</span>
                  </div>
                  <div class="about-culture-list-des p-l-40">{{item.des}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide about-bj about-international container" :class="[language == 'en' ? 'flex' : '']">
            <div :class="['about-bj-box', language == 'en' ? 'center_up_down' : '']">
              <div class="about-international-title">{{$t('about.international.title')}}</div>
              <div class="about-bj-list textj">
                <template v-if="language == 'en'">
                  <p class="about-bj-item p-b-10" :class="internationalStatus ? 'show' : ''" v-for="(item, index) in international" :key="index" v-html="item"></p>
                </template>
                <template v-else>
                  <p class="p-b-10" v-for="(item, index) in international" :key="index">
                    <span v-for="($item, $index) in item" :key="index + '_' +$index" :class="internationalActive >= $index + getNum('international', index) ? 'on' : ''" v-html="$item"></span>
                  </p>
                </template>
              </div>
            </div>
          </div>
          <div class="swiper-slide about-history flex flex_col">
            <div class="about-history-title">{{$t('about.history.title')}}</div>
            <div class="about-history-bj">
              <div class="about-history-bj-img" :style="{'transition-duration': `1500ms`, 'transform': `rotate(${active * 34}deg)`}"></div>
              <div class="about-history-bj-img small" :style="{'transition-duration': `1500ms`, 'transform': `rotate(${active * 20}deg)`}"></div>
              <div class="inner"></div>
            </div>
            <div class="about-history-main flex_1 flex flex_col">
              <div class="about-history-list flex_1 flex justify_content_center align_items_center">
                <div class="about-history-list-title">{{ $t('about.history.list')[active].time }}</div>
                <div class="flex_1 about-history-list-box" @mouseenter="closeTime()" @mouseleave="mouseleaveHistory()">
                  <p v-for="(item, index) in $t('about.history.list')[active].des" :key="`qw_${index}`" :class="[language != 'en' ? 'flex' : '']" ><span :class="['p-r-10', language != 'en' ? 'fontw list-time' : '']" v-html="item.time"></span><span :class="[language != 'en' ? 'flex_1' : 'list-des']" v-html="item.content"></span></p>
                </div>
              </div>
              <div class="about-history-timeline">
                <div class="about-history-longline"></div>
                <div class="flex box">
                  <div class="speed-box">
                    <div class="speed" :style="{width: `${ 100 / ($t('about.history.list').length - 1) * active}%`}"></div>
                  </div>
                  <div :class="['item', active == index ? 'active' : '', index != $t('about.history.list').length - 1 ? 'flex_1' : '']" v-for="(item, index) in $t('about.history.list')" :key="`11_${index}`">
                    <div class="about-history-circle" @click="setActive(index)" @mouseenter="mouseenterHistory(index)" @mouseleave="mouseleaveHistory(index)"></div>
                    <p class="about-history-des">{{item.time}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide heiauto">
            <Footer id="footer" class="posrel"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from '@/utils'
import HeadMenu from '@/components/pc/HeadMenu' // 头部
import Footer from '@/components/pc/Footer' // 底部
import { mapGetters } from 'vuex'
export default {
  name: 'about',
  components: {
    HeadMenu,
    Footer
  },
  data () {
    return {
      activeMenuIndex: this.$route.meta.checked, // 选中菜单
      active: 0,
      scroll: 0,
      scroll_top: 0,
      scroll_type: 'up',
      aboutStatus: false,
      cultureStatus: false,
      internationalStatus: false,
      realIndex: 0,
      timer: null,
      timerArr: [],
      aboutActive: 0,
      internationalActive: 0,
      international: [],
      about: []
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created () {
    this.international = deepClone(this.$t('about.international.list'))
    this.about = deepClone(this.$t('about.about.list'))
  },
  mounted () {
    this.closetimerArr()
    this.closeTime()
    if (this.language !== 'en') {
      this.setShowTxt('about', 'aboutActive')
    }
    this.setSwiper()
  },
  methods: {
    setSwiper () {
      const _this = this
      this.mySwiperPC = new this.$Swiper('#aboutSwiper', {
        threshold: 100, // 必须拖动大于100px后slide才会开始移动
        direction: 'vertical', // 上下
        mousewheel: true, // 鼠标滚动切换
        slidesPerView: 'auto',
        on: {
          init: function (swiper) {
            // _this.aboutStatus = true
          },
          slideChangeTransitionStart: function () {
            if (this.activeIndex > _this.realIndex) {
              _this.scroll_type = 'down'
            } else {
              _this.scroll_type = 'up'
            }
            _this.realIndex = this.activeIndex
            _this.closetimerArr()
            _this.closeTime()
            if (this.activeIndex === 0) {
              if (_this.language === 'en') {
              } else {
                _this.setShowTxt('about', 'aboutActive')
              }
            } else if (this.activeIndex === 1) {
              _this.cultureStatus = true
            } else if (this.activeIndex === 2) {
              if (_this.language === 'en') {
                // _this.internationalStatus = true
              } else {
                _this.setShowTxt('international', 'internationalActive')
              }
            } else if (this.activeIndex === 3) {
              _this.startLoop()
            }
          }
        }
      })
    },
    getNum (type, index) {
      let num = 0
      for (let i = 0; i < index; i++) {
        num += this[type][i].length
      }
      return num
    },
    setActive (index) {
      this.active = index
      this.closeTime()
    },
    mouseenterHistory (index) {
      console.log(index, this.active)
      if (index === this.active) {
        this.closeTime()
      }
    },
    mouseleaveHistory (index) {
      this.startLoop()
    },
    startLoop () {
      this.closeTime()
      const duration = this.active > 3 ? 2000 : 3000
      this.timer = setInterval(() => {
        this.active > this.$t('about.history.year').length - 2 ? this.active = 0 : this.active++
        this.closeTime()
        this.startLoop()
      }, duration)
    },
    closeTime () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    setShowTxt (type, val) {
      this.setIntervalFun(type, val)
    },
    setIntervalFun (type, val) {
      this.closetimerArr()
      // // const txtLen = this[type].map(item => item.length).reduce((a, b) => a + b)
      const txtLen = this.getNum(type, this[type].length)
      this.timerArr = setInterval(() => {
        // wenlen大于data.content的长度，停止计时器
        if (this[val] < txtLen) {
          if (type === 'international') {
            this[val] += 5
          } else {
            this[val] += 2
          }
        } else {
          this.closetimerArr()
        }
      }, 10)
    },
    closetimerArr () {
      if (this.timerArr) {
        clearInterval(this.timerArr)
        this.timerArr = null
      }
    }
  },
  beforeDestroy () { // 页面关闭时清除定时器
    this.mySwiper = null
    this.closeTime()
    this.closetimerArr()
  }
}
</script>
<style lang="less" scoped>
@keyframes LeftShow {
  0% {
    opacity: 0;
    left: -1em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}
@-webkit-keyframes LeftShow {
  0% {
    opacity: 0;
    left: -1em;
  }

  to {
    opacity: 1;
    left: 0;
  }
}
@keyframes LeftRightShow {
  0% {
    opacity: 0;
    left: -400PX;
  }
  50% {
    opacity: 0.3;
    left: -200PX;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}
@-webkit-keyframes LeftRightShow {
  0% {
    opacity: 0;
    left: -400PX;
  }
  50% {
    opacity: 0.3;
    left: -200PX;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}
.pc .about {
  color: #ffffff;
  .about-swiper {
    height: 100vh;
    overflow: hidden;
  }
  .about-bj {
    height: 100vh;
    position: relative;
    background: linear-gradient(60deg, #00A0E9 0%, #0046A3 100%);
    padding-top: 90PX;
    padding-left: 132PX;
    .about-bj-img {
      max-height: calc(100% - 20PX);
      max-width: 100%;
      right: 0;
    }
    .about-bj-box {
      padding: 10% 20% 0 10%;
      width: 70%;
      .about-bj-txt {
        position: relative;
        display: inline-block;
        left: 0;
      }
      .about-bj-list {
        padding-top: 80PX;
        line-height: 22PX;
        color: rgba(255, 255, 255, 0.8);
        span {
          position: relative;
          text-align: center;
          left: -1em;
          opacity: 0;
          // display: inline-block;
          &.on {
            animation: LeftShow 0.25s ease-out both;
          }
        }
      }
    }
  }
  .about-culture {
    background: linear-gradient(310deg, #116EB7 0%, #045798 100%);
    padding-top: 0;
    padding-left: 16%;
    .about-culture-box {
      padding-left: 56%;
      padding-top: 100PX;
      top: calc(50% - 50PX);
      background-image: url(../../../assets/images/about/2.png);
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: bottom left;
      .about-about-culture-title {
        font-size: 40PX;
        line-height: 56PX;
        padding-bottom: 30PX;
      }
    }
    .about-culture-list {
      font-size: 16PX;
      line-height: 34PX;
      padding: 20PX 0;
      position: relative;
      left: 400PX;
      opacity: 0;
      .about-culture-list-title {
        font-size: 24PX;
        padding: 10PX 0;
      }
      .about-culture-list-img {
        width: 40PX;
      }
      &.show {
        left: 0;
        opacity: 1;
      }
      &:nth-child(2) {
        transition: all .3s;
      }
      &:nth-child(3) {
        transition: all .6s;
      }
      &:nth-child(4) {
        transition: all .9s;
      }
      &:nth-child(5) {
        transition: all 1.2s;
      }
    }
  }
  .about-international {
    background: #014D89;
    background-image: url(../../../assets/images/about/3.png);
    background-repeat: no-repeat;
    background-position: right 10% bottom 40%;
    background-size: auto 60%;
    .about-international-title {
      font-size: 40PX;
    }
    .about-bj-box  {
      padding: 6% 0% 0 6%;
      width: 53%;
      .about-bj-list {
        padding-top: 48PX;
        color: rgba(255, 255, 255, 0.8);
        span {
          position: relative;
          i {
            font-style: inherit;
          }
        }
      }
    }
  }
  .about-history {
    padding: 100PX 8vw 0 8vw;
    height: 100vh;
    background: #0067B2;
    position: relative;
    .about-history-bj {
      position: absolute;
      height: calc(100% - 100PX);
      width: 90vw;
      left: 5vw;
      overflow: hidden;
      opacity: 0.8;
      .about-history-bj-img {
        width: 90vw;
        position: absolute;
        background-image: url('../../../assets/images/about/circle_big.png');
        height: 90vw;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: 0 0;
        bottom: -56vw;
        left: 0;
        opacity: 0.6;
        &.small {
          background-image: url('../../../assets/images/about/circle_small.png');
          height: 80vw;
          width: 80vw;
          // left: 5%;
          // bottom: -55vw;
          // width: 100%;
          // height: 90vw;
          bottom: -53vw;
          left: 5vw;
        }
      }
      .inner {
        width: 60vw;
        position: absolute;
        height: 60vw;
        left: 15vw;
        bottom: -45vw;
        border: 1PX solid #4e93c9;
        border-radius: 50%;
        opacity: 0.6;
      }
    }
    .about-history-title {
      font-size: 40PX;
      line-height: 56PX;
      padding-top: 42PX;
      text-align: center;
    }
    .about-history-list {
      line-height: 40PX;
      width: 60%;
      margin: 0 auto;
      position: relative;
      .list-time {
        opacity: 0.6;
      }
      .about-history-list-title {
        font-size: 60PX;
        font-weight: bold;
        padding-right: 1.4em;
        width: 3.4em;
      }
      .about-history-list-box {
        max-height: 60vh;
        overflow: auto;
      }
    }
    .about-history-timeline {
      position: relative;
      z-index: 2;
      .box {
        padding: 0 10% 54PX;
        position: relative;
      }
      .about-history-longline {
        // position: absolute;
        // width: 100%;
        height: 4PX;
        background: rgba(255, 255, 255, 0.2);
        &::before {
          content: '';
          height: 4PX;
          width: calc(10% + 12PX);
          background: #61c5ea;
          position: absolute;
        }
      }
      .item {
        position: relative;
        padding-top: 20PX;
        color: rgba(255, 255, 255, 0.6);
        &:last-child {
          position: absolute;
          right: calc(10% + 15PX)
        }
      }
      .speed-box {
        position: absolute;
        width: calc(100% - 20%);
        margin-left: 9PX;
      }
      .speed {
        height: 4PX;
        background: linear-gradient(90deg, #61c5ea 0%, #3a4ed3 100%);
        position: absolute;
        top: -4PX;
        left: -7PX;
        transition: width 1s;
      }
      .about-history-circle {
        position: absolute;
        width: 17PX;
        height: 17PX;
        top: -11PX;
        left: 0PX;
        background: #FFFFFF;
        border-radius: 50%;
        border: 3PX solid #00A0E9;
        cursor: pointer;
        transition: all .2s;
        &:hover {
          width: 21PX;
          height: 21PX;
          top: -12PX;
          left: -2PX;
          border-color: #ffffff;
          background: #00A0E9;
          box-shadow: 0 0 5PX 5PX rgba(255, 255, 255, 0.2);
        }
      }
      .item.active {
        color: #ffffff;
        .about-history-circle {
          width: 20PX;
          height: 20PX;
          top: -12PX;
          left: -2PX;
          border-color: #ffffff;
          background: #00A0E9;
          // box-shadow: 0 0 5PX 5PX rgba(255, 255, 255, 0.2);
          animation: historyCircle 2s linear infinite;
        }
      }
      .about-history-des {
        position: absolute;
        left: -0.5em;
      }
    }
  }
}
.pc.en .about {
  .about-bj .about-bj-box {
    .about-bj-title {
      white-space: nowrap;
    }
    .about-bj-list {
      .about-bj-item {
        // opacity: 0;
        position: relative;
        // left: -400PX;
        &.show {
          // left: 0;
          // opacity: 1;
        }
        &.show:nth-child(2) {
          // transition: all .3s;
          animation: LeftRightShow 0.3s linear;
        }
        &.show:nth-child(3) {
          // transition: all .6s;
          animation: LeftRightShow 0.6s linear;
        }
        &.show:nth-child(4) {
          // transition: all .9s;
          animation: LeftRightShow 0.9s linear;
        }
        &.show:nth-child(5) {
          // transition: all 1.2s;
          animation: LeftRightShow 1.2s linear;
        }
        &.show:nth-child(6) {
          // transition: all 1.5s;
          animation: LeftRightShow 1.5s linear;
        }
        &.show:nth-child(7) {
          // transition: all 1.8s;
          animation: LeftRightShow 1.8s linear;
        }
        &.show:nth-child(8) {
          // transition: all 2.1s;
          animation: LeftRightShow 2.1s linear;
        }
        &.show:nth-child(9) {
          // transition: all 2.4s;
          animation: LeftRightShow 2.4s linear;
        }
        &.show:nth-child(10) {
          // transition: all 2.7s;
          animation: LeftRightShow 2.7s linear;
        }
        &.show:nth-child(11) {
          // transition: all 3.0s;
          animation: LeftRightShow 3.0s linear;
        }
        &.show:nth-child(12) {
          // transition: all 3.3s;
          animation: LeftRightShow 3.3s linear;
        }
      }
    }
  }
  .about-history {
    .about-history-list {
      width: 76%;
      .list-des {
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1680PX) and (min-width: 1600PX) {
  .pc .about {
    .about-international {
      .about-international-title {
        font-size: 40PX;
      }
      .about-bj-box  {
        width: 60%;
        padding-right: 2%;
      }
    }
  }
}
@media screen and (max-width: 1600PX) and (min-width: 1440PX) {
  .pc .about {
    .about-bj {
      .about-bj-box {
        padding: 6% 7% 0 10%;
      }
    }
    .about-international {
      .about-international-title {
        font-size: 40PX;
      }
      .about-bj-box  {
        width: 80%;
        padding: 5% 0% 0 10%;
      }
    }
  }
  .zh .about {
    .about-bj {
      .about-bj-img {
        max-width: 100%;
      }
      .about-bj-box {
        .about-bj-title {
          font-size: 52PX;
          line-height: 98PX;
        }
      }
    }
  }
}
@media screen and (max-width: 1440PX) {
  .pc .about {
    .about-history {
      padding-top: 40PX;
      .about-history-title {}
      .about-history-list {
        width: 96%;
      }
      .about-history-timeline .box {
        padding-bottom: 20PX;
      }
    }
  }
}
@media screen and (max-width: 1440PX) and (min-width: 1400PX) {
  .pc .about {
    .about-bj {
      .about-bj-box {
        padding: 6% 10% 0 10%;
        .about-bj-title {
          font-size: 52PX;
          line-height: 98PX;
        }
      }
    }
    .about-culture {
      padding-top: 40PX;
      .about-culture-box {
        padding-left: 58%;
        .about-about-culture-title {
          font-size: 30PX;
          line-height: 46PX;
        }
      }
      .about-culture-list {
        font-size: 14PX;
        line-height: 26PX;
        padding: 14PX 0;
        .about-culture-list-title {
          font-size: 20PX;
        }
      }
    }
    .about-international {
      .about-international-title {
        font-size: 30PX;
      }
      .about-bj-box  {
        width: 75%;
        padding: 0 0% 0 10%;
      }
    }
  }
}
@media screen and (max-width: 1400PX) {
  .pc .about {
    .about-international {
      .about-bj-box  {
        width: 60%;
        padding: 40PX 5% 0 0;
      }
    }
  }
}
@media screen and (max-width: 1366PX) {
  .pc .about {
    .about-bj {
      .about-bj-img {
        max-height: calc(80%);
        width: auto !important;
      }
      .about-bj-box {
        padding: 2% 0 0 0;
        .about-bj-title {
          font-size: 46PX;
          line-height: 98PX;
        }
        .about-bj-list {
          padding-top:40PX;
        }
      }
    }
    .about-international {
      .about-international-title {
        font-size: 40PX;
      }
      .about-bj-box  {
        width: 80%;
        padding: 40PX 0% 0 0;
        .about-bj-list {
          font-size: 14PX;
          padding-top: 40PX;
        }
      }
    }
    .about-culture {
      .about-culture-box {
        background-size: auto 90%;
      }
      .about-culture-list {
        font-size: 14PX;
        line-height: 30PX;
        padding: 30px 0;
        .about-culture-list-title {
          font-size: 20PX;
          padding: 8PX 0;
        }
        .about-culture-list-img {
          width: 40PX;
        }
      }
    }
    .about-history {
      .about-history-list {
        width: 70%;
        line-height: 32PX;
        .about-history-list-title {
          font-size: 46PX;
        }
      }
    }
  }
}
@media screen and (width: 1280PX) and (min-height: 700PX) {
  .pc .about {
    .about-international {
      .about-international-title {
        font-size: 40PX;
      }
      .about-bj-box  {
        width: 70%;
        padding: 60PX 0% 0 0;
        .about-bj-list {
          font-size: 16PX;
          padding-top: 40PX;
        }
      }
    }
  }
}
@media screen and (width: 1280PX) and (max-height: 690PX) {
  .pc .about {
    .about-culture {
      .about-culture-box {
        .about-about-culture-title {
          font-size: 26PX;
          line-height: 40PX;
        }
      }
      .about-culture-list {
        font-size: 12PX;
        line-height: 22PX;
        padding: 10PX 0;
        .about-culture-list-title {
          font-size: 18PX;
        }
      }
    }
    .about-international {
      .about-international-title {
        font-size: 40PX;
      }
      .about-bj-box  {
        width: 80%;
        .about-bj-list {
          font-size: 14PX;
          padding-top: 20PX;
        }
      }
    }
  }
}
@media screen and (max-width: 1152PX) {
  .pc .about {
    .about-bj {
      .about-bj-box {
        width: 40%;
      }
    }
    .about-international {
      .about-bj-box  {
        width: 60%;
      }
    }
  }
}
@media screen and (max-width: 1024PX) {
  .pc .about {
    .about-international {
      .about-bj-box  {
        width: 80%;
        .about-bj-list {
          font-size: 14PX;
          padding-top: 20PX;
          line-height: 20PX;
        }
      }
    }
  }
}
@media screen and (max-height: 500PX) {
  .pc .about {
    font-size: 14PX;
    .about-bj {
      padding-top: 60PX;
      .about-bj-img {
        max-height: calc(80%);
        width: auto !important;
      }
      .about-bj-box {
        padding-top: 30PX;
        position: absolute;
        width: 60%;
        .about-bj-list {
          padding-top: 40PX;
        }
      }
    }
    .about-international {
      .about-international-title {
        font-size: 32PX;
      }
      .about-bj-box  {
        width: 84%;
        padding-top: 0;
        .about-bj-list {
          font-size: 14PX;
          padding-top: 20PX;
          line-height: 20PX;
        }
      }
    }
    .about-history {
      padding-top: 40PX;
      .about-history-list {
        width: 70%;
        line-height: 28PX;
        .about-history-list-title {
          font-size: 46PX;
        }
      }
      .about-history-timeline .box {
        padding-bottom: 0PX;
      }
    }
  }
  .pc.zh .about {
    .about-bj {
      .about-bj-box {
        .about-bj-title {
          font-size: 36PX;
          line-height: 78PX;
          &::after {
            width: 140PX;
            left: 0;
          }
        }
        .about-bj-des {
          font-size: 16PX;
          line-height: 30PX;
          padding-left: 4PX;
        }
      }
    }
  }
  .pc.en .about {
    .about-international {
      .about-bj-box  {
        width: 90%;
        .about-bj-list {
          line-height: 16PX;
        }
      }
    }
    .about-history {
      .about-history-list {
        width: 76%;
        line-height: 26PX;
      }
    }
  }
}
</style>
